import { CultureKeyType, CurrencyKeyType } from '@constants/app.constants';
import { NullableString } from '@models/app.models';
import {
  Address,
  Gender,
  Name,
  PaymentMethodType,
  PhoneNumber,
  PhoneNumberType,
} from '@models/booking.models';

export interface UserCustomerCreateRequest {
  password: string;
  person?: PersonCreateRequest;
  sendRegistrationConfirmation: boolean;
  username: string;
}

export interface PersonCreateRequest {
  addresses?: PersonAddressCreateRequest[];
  affiliates?: PersonAffiliation[];
  aliases?: PersonAliasRequest[];
  comments?: PersonCommentRequest[];
  customerNumber?: string;
  details?: PersonBasicInformation;
  emailAddresses: EmailCreateRequest[];
  name: Name;
  notificationPreference?: NotificationPreference2;
  phoneNumbers?: PersonPhoneNumberRequest[];
  preferences?: PersonPreferenceCreateRequest[];
  programs?: PersonCustomerProgramCreateRequest[];
  status?: PersonStatus;
  storedPayments?: PersonStoredPaymentRequest[];
  travelDocuments?: PersonTravelDocumentRequest[];
  type: PersonType;
}

export interface PersonEmailAddress {
  default: boolean;
  email: string;
  personEmailKey: string;
  type: string;
}

export interface EmailCreateRequest {
  default: boolean;
  email: string;
  type: string;
}

export interface EmailEditRequest {
  default: boolean;
  email: string;
}

export interface PersonPhoneNumber extends PhoneNumber {
  default: boolean;
  number: string;
  personPhoneNumberKey: string;
  type: PhoneNumberType;
}

export interface PersonPhoneNumberRequest extends PhoneNumber {
  default: boolean;
  number: string;
  type: PhoneNumberType;
}

export interface PersonAddressCreateRequest extends Address {
  addressTypeCode: string;
  defaut: boolean;
}

export interface PersonStoredPaymentRequest {
  accountNamePaymentMethodType: string;
  accountNumber: string;
  defaultPaymentMethodType: boolean;
  expirationPaymentMethodType: Date;
  paymentMethodCodePaymentMethodType: string;
  paymentMethodType: PaymentMethodType;
}

export interface PersonTravelDocumentRequest {
  birthCountryPaymentMethodType: string;
  dateOfBirthPaymentMethodType: Date;
  default: boolean;
  documentTypeCodePaymentMethodType: string;
  expirationDatePaymentMethodType: Date;
  genderPaymentMethodType: Gender;
  issuedByCodePaymentMethodType: string;
  issuedDatePaymentMethodType: Date;
  namePaymentMethodType: Name;
  nationalityPaymentMethodType: string;
  numberPaymentMethodType: string;
}

export interface PersonCustomerProgramCreateRequest {
  defaultPaymentMethodType: boolean;
  effectiveDatePaymentMethodType: Date;
  expirationDatePaymentMethodType: Date;
  programCode: string;
  programLevelCodePaymentMethodType: string;
  programNumberPaymentMethodType: string;
}

export interface PersonCommentRequest {
  text: string;
  type: PersonCommentType;
}

export enum PersonCommentType {
  Default = 0,
  Itinerary = 1,
  Manifest = 2,
  Alert = 3,
  Archive = 4,
}

export interface PersonPreferenceCreateRequest {
  code: string;
  value: string;
}

export interface PersonAliasRequest extends Name {
  type: PersonAliasType;
}

export enum PersonAliasType {
  Alias = 0,
  Variant = 1,
}

export interface PersonAffiliation {
  name: string;
  personAffiliationKey: string;
}

export enum PersonType {
  None = 0,
  Customer = 1,
  Agent = 2,
}

export enum PersonStatus {
  Active = 0,
  Terminated = 1,
  Suspended = 2,
}

export interface PersonBasicInformation {
  dateOfBirth?: NullableString;
  gender: Gender;
  nationalIdNumber?: string;
  nationality?: string;
  passengerType?: string;
  preferredCultureCode?: CultureKeyType | null;
  preferredCurrencyCode?: CurrencyKeyType | null;
  residentCountry?: NullableString;
}

export enum NotificationPreference2 {
  None = 0,
  Promotional = 1,
}
